import Instance from './resource';
import $ from "jquery";
export default {
    //调用微信JS api 支付
    jsApiCall(jsonstring) {
        WeixinJSBridge.invoke(
            'getBrandWCPayRequest',
            jsonstring,//josn串
            function (res) {
                WeixinJSBridge.log(res.err_msg);
                alert(res.err_code + res.err_desc + res.err_msg);
            }
        );
    },

    callpay(jsonstring) {
        if (typeof WeixinJSBridge == "undefined") {
            if (document.addEventListener) {
                document.addEventListener('WeixinJSBridgeReady', jsApiCall(jsonstring), false);
            }
            else if (document.attachEvent) {
                document.attachEvent('WeixinJSBridgeReady', jsApiCall(jsonstring));
                document.attachEvent('onWeixinJSBridgeReady', jsApiCall(jsonstring));
            }
        }
        else {
            jsApiCall();
        }
    }
}


// WEBPACK FOOTER //
// ./src/api/callWeixin.js